import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { AppFooter } from "scmp-app/components/app-footer";
import { useContentSchemaRenderImage } from "scmp-app/components/schema-render/common/image/hooks";
import { ContentSchemaRender } from "scmp-app/components/schema-render/content";
import type { postiesPagesPage$key } from "scmp-app/queries/__generated__/postiesPagesPage.graphql";

import {
  Content,
  Heading1,
  Heading2,
  Heading3,
  Heading4,
  Heading6,
  Headline,
  Paragraph,
} from "./styles";

type Props = {
  className?: string;
  reference: postiesPagesPage$key;
};
export const PostiesPages: FunctionComponent<Props> = ({ className, reference: reference_ }) => {
  const page = useFragment(
    graphql`
      fragment postiesPagesPage on Page {
        headline
        body {
          json
        }
        ...contentSchemaRenderContent
      }
    `,
    reference_,
  );

  const { ComponentWithExtraProps: ImageWithExtraProps } = useContentSchemaRenderImage({
    enableResize: true,
  });

  return (
    <div className={className}>
      <Content>
        <Headline>{page.headline}</Headline>
        <ContentSchemaRender
          extraComponentMap={{
            h1: Heading1,
            h2: Heading2,
            h3: Heading3,
            h4: Heading4,
            h6: Heading6,
            img: ImageWithExtraProps,
            p: Paragraph,
          }}
          reference={page}
          schema={page.body?.json}
        />
      </Content>
      <AppFooter variant="posties" />
    </div>
  );
};

PostiesPages.displayName = "PostiesPages";
